import type {
  MovingTypeSpecificationAttribute,
  DynamicAttributeTypeJson,
} from './movingTypeSpec';

export type MovingTypeAttributeKind =
  | 'STRING'
  | 'BOOLEAN'
  | 'NUMBER'
  | 'INT'
  | 'DATE'
  | 'DATE_RANGE'
  | 'TIME'
  | 'STRUCTURED_DEPARTURE_ADDRESS'
  | 'ENUM'
  | 'CHOICE_WITH_CUSTOM';

export interface ResolvedMovingTypeAttributeType {
  kind: MovingTypeAttributeKind;
  enumValues?: string[];
  enumDisplayNames?: Record<string, string>;
}

function readTypeObject(raw: DynamicAttributeTypeJson): Record<string, unknown> | null {
  if (raw !== null && typeof raw === 'object' && !Array.isArray(raw)) {
    return raw as Record<string, unknown>;
  }
  return null;
}

export function resolveMovingTypeAttribute(
  attr: MovingTypeSpecificationAttribute
): ResolvedMovingTypeAttributeType {
  const raw = attr.type;
  const obj = readTypeObject(raw);

  const mergedEnumValues =
    attr.enumValues ??
    (typeof obj?.enumValues === 'object' && Array.isArray(obj.enumValues)
      ? (obj.enumValues as string[])
      : undefined) ??
    (typeof obj?.values === 'object' && Array.isArray(obj.values)
      ? (obj.values as string[])
      : undefined);

  const mergedDisplayNames =
    obj && typeof obj.enumDisplayNames === 'object' && obj.enumDisplayNames !== null
      ? (obj.enumDisplayNames as Record<string, string>)
      : undefined;

  const typeToken =
    typeof raw === 'string'
      ? raw
      : obj && 'type' in obj && obj.type != null
        ? String(obj.type)
        : 'STRING';

  const upper = typeToken.toUpperCase().replace(/\s+/g, '_');

  let kind: MovingTypeAttributeKind = 'STRING';
  if (upper === 'BOOLEAN') kind = 'BOOLEAN';
  else if (upper === 'NUMBER') kind = 'NUMBER';
  else if (upper === 'INT' || upper === 'INTEGER') kind = 'INT';
  else if (upper === 'DATE') kind = 'DATE';
  else if (upper === 'DATE_RANGE') kind = 'DATE_RANGE';
  else if (upper === 'TIME') kind = 'TIME';
  else if (upper === 'STRUCTURED_DEPARTURE_ADDRESS') kind = 'STRUCTURED_DEPARTURE_ADDRESS';
  else if (upper === 'ENUM') kind = 'ENUM';
  else if (upper === 'CHOICE_WITH_CUSTOM' || upper === 'CHOICEWITHCUSTOM')
    kind = 'CHOICE_WITH_CUSTOM';

  return {
    kind,
    enumValues: mergedEnumValues,
    enumDisplayNames: mergedDisplayNames,
  };
}

export function isSchemaFormKind(kind: MovingTypeAttributeKind): boolean {
  return (
    kind === 'STRING' ||
    kind === 'BOOLEAN' ||
    kind === 'NUMBER' ||
    kind === 'INT' ||
    kind === 'DATE' ||
    kind === 'ENUM'
  );
}
